export const ONBOARDING_STATES = {
  PENDING_ONBOARDING: 'Pending Onboarding',
  IN_ONBOARDING_PROCESS: 'In the Onboarding Process',
  PENDING_VERIFICATION: 'Pending Verification',
  UPDATES_REQUIRED: 'Updates Required',
  REJECTED: 'Rejected',
  LIVE: 'Live',
} as const;

export const ONBOARDING_WITHOUT_STATES = {
  NO_ONBOARDING: 'No onboarding profile linked to the dashboard process.',
  ONBOARDING_WITH_ANOTHER_PARTNER:
    'You are already onboarded with another partner.',
  INVALID_PROFILE: 'Invalid profile.',
} as const;

export const ONBOARDING_CONVERTED_STATUS = {
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  BRAND: 'brand',
} as const;

export const SUPPORT_EMAIL = 'support@paymob.com';

export const SPECIAL_HANDLERS = {
  MAIL_SUPPORT: 'MAIL_SUPPORT',
};

export const MODAL_TYPES = {
  UPDATES_REQUIRED: 'updatesRequired',
};
